module.exports = "/_next/static/images/minoringo_appearance_out-3b44c19eeeb5cf2efb63100123f8bbd9.jpg";